import { httpClient } from '@/shared/api/httpClient';

export type EstadoBackup = {
  ultimoEnvioEm: string | null;
  ultimoHash: string | null;
  ultimaTentativaEm: string | null;
  ultimoErro: string | null;
  falhasConsecutivas: number;
};

export type StatusBackup = {
  habilitado: boolean;
  clientId: string | null;
  intervaloMs: number;
  url: string | null;
  rodando: boolean;
  estado: EstadoBackup;
};

export type ItemHistoricoRemoto = {
  arquivo: string;
  tamanhoBytes: number;
  criadoEm: string;
};

export type Conectividade = {
  online: boolean;
  latenciaMs: number | null;
  status: number | null;
  mensagem: string | null;
};

export type ConfigPersistida = {
  tokenConfigurado: boolean;
  url: string | null;
  urlPersistida: boolean;
  intervaloMs: number;
};

export type ResultadoSalvarConfig = ConfigPersistida & {
  alterouToken: boolean;
  alterouUrl: boolean;
  alterouIntervalo: boolean;
};

export type ResultadoCiclo =
  | { tipo: 'enviado'; tamanhoBytes: number }
  | { tipo: 'sem-alteracoes' }
  | { tipo: 'desabilitado'; motivo: string }
  | { tipo: 'em-execucao' }
  | { tipo: 'falha'; mensagem: string };

export type RespostaRodarAgora = {
  resultado: ResultadoCiclo;
  status: StatusBackup;
};

export type ResultadoAutoRegistro =
  | { tipo: 'ja-tem-token' }
  | { tipo: 'registrado' }
  | { tipo: 'recuperado' }
  | { tipo: 'ja-registrado' }
  | { tipo: 'desabilitado' }
  | { tipo: 'falha'; motivo: string };

export type RespostaAutoRegistro = {
  resultado: ResultadoAutoRegistro;
  status: StatusBackup;
};

export type ResultadoSalvarNome =
  | { tipo: 'salvo'; nome: string | null }
  | { tipo: 'sem-token' }
  | { tipo: 'falha'; status: number; mensagem: string };

export const backupApi = {
  status: () => httpClient.get<StatusBackup>('/api/backup/status'),
  rodarAgora: () => httpClient.post<RespostaRodarAgora>('/api/backup/run', {}),
  conectividade: () => httpClient.get<Conectividade>('/api/backup/conectividade'),
  historicoRemoto: () => httpClient.get<ItemHistoricoRemoto[]>('/api/backup/historico-remoto'),
  restaurar: (arquivo: string) =>
    httpClient.post<{ backupAnterior: string }>('/api/backup/restaurar', { arquivo }),
  excluirItemRemoto: (arquivo: string) =>
    httpClient.delete<void>(`/api/backup/historico-remoto/${encodeURIComponent(arquivo)}`),
  excluirTodosRemoto: () =>
    httpClient.delete<{ removidos: number }>('/api/backup/historico-remoto'),
  obterConfig: () => httpClient.get<ConfigPersistida>('/api/backup/config'),
  salvarConfig: (corpo: { token?: string; url?: string; intervaloMs?: number }) =>
    httpClient.put<ResultadoSalvarConfig>('/api/backup/config', corpo),
  removerToken: () => httpClient.delete<void>('/api/backup/config/token'),
  autoRegistrar: () => httpClient.post<RespostaAutoRegistro>('/api/backup/auto-registrar', {}),
  obterNome: () => httpClient.get<{ nome: string | null }>('/api/backup/nome'),
  salvarNome: (nome: string) =>
    httpClient.put<ResultadoSalvarNome>('/api/backup/nome', { nome }),
};

export type ResultadoFeedback =
  | { tipo: 'enviado' }
  | { tipo: 'sem-token' }
  | { tipo: 'falha'; status: number; mensagem: string };

export const feedbackApi = {
  enviar: (mensagem: string, contexto?: string) =>
    httpClient.post<ResultadoFeedback>('/api/feedback', { mensagem, contexto }),
};
